var _path, _path2, _rect, _rect2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkipCardEmpty = function SvgSkipCardEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 251,
    viewBox: "0 0 185 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192H185V238.34C185 245.332 179.332 251 172.34 251H12.66C5.66808 251 0 245.332 0 238.34V192Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0439 208.35C34.8392 207.861 33.4916 207.861 32.2868 208.35L29.3661 209.534L42.1557 214.508L46.6549 212.769C46.4737 212.619 46.2679 212.495 46.042 212.403L36.0439 208.35ZM47.4987 214.587L35.1651 219.353V233.917C35.4635 233.856 35.7577 233.767 36.0439 233.651L46.042 229.598C46.9226 229.241 47.4987 228.386 47.4987 227.436V214.587ZM33.1651 233.917V219.353L20.832 214.587V227.436C20.832 228.386 21.4082 229.241 22.2887 229.598L32.2868 233.651C32.5728 233.767 32.8668 233.856 33.1651 233.917ZM21.6757 212.769L34.1651 217.595L39.3877 215.577L26.6645 210.629L22.2887 212.403C22.0628 212.495 21.8569 212.619 21.6757 212.769Z",
    fill: "#DADBE7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.1655,
    y: 211.669,
    width: 98,
    height: 6.33138,
    rx: 3.16569,
    fill: "#DADBE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1655,
    y: 224.332,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#DADBE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6561C0 6.66417 5.66807 0.996094 12.66 0.996094H172.324C179.316 0.996094 184.984 6.66417 184.984 13.6561V192.312H0V13.6561Z",
    fill: "#DADBE7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkipCardEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/skip-card-empty.ad80dd6f17966be8fc338ba41b72add8.svg";